export enum UserRole {
  Nurse = 1,
  OrganizationAdmin = 2,
  FacilityAdmin = 3,
  Specialist = 4
}
